import { createRouteWithLayout } from 'util/resource-router';
import { ScreenName } from 'view/common/constants';
import { VerifyEmail } from 'view/verify-email';
import { anonymousScreenLayout } from '../common/constants';

const userVerifyEmail = {
    resources: [],
    name: 'verify-email',
    path: `/user/verify-email`,
    exact: true,
    component: VerifyEmail,
};

export const userVerifyEmailRoute = createRouteWithLayout(
    userVerifyEmail,
    ScreenName.VERIFY_EMAIL,
    anonymousScreenLayout
);
